export default __webpack_public_path__ + "static/Airtel-7ef5282766ea24217d249fc5c797af6d.png";